import React, { useEffect, useState } from 'react'

import language from '../../data/language.json'

import Cards from '../Cards/Cards'
import Select from 'react-select'

import './charWindow.scss'
import JobSelect from './subComponents/JobSelect'
import StatSelect from './subComponents/StatSelect'
import BaseLevelSelect from './subComponents/BaseLevelSelect'
import JobLevelSelect from './subComponents/JobLevelSelect'
// import SubStats from '../SubStats/SubStats'

import { serializeBuild, deserializeBuild } from '../../utils/buildSerializer'
import {
	ensureSlots,
	readSlot,
	writeSlot,
	buildOptions,
} from '../../utils/buildStorage'
import { pushSlotToCloud, BUILDS_SYNCED_EVENT } from '../../utils/buildsCloud'
import { cleanBuffs } from '../../constants/buffs'
import { useAuth } from '../../contexts/auth'

//context
import { useContext } from 'react'
//character context
import { CharacterContext } from '../../contexts/character'
//subStat context
import { SubStatsContext } from '../../contexts/subStats'
//dn context
import { DBContext } from '../../contexts/databases'
//User Interface Context
import { UIContext } from '../../contexts/ui'
//comparison context
import { ComparisonContext, ComparisonSelect } from '../../contexts/comparison'
function CharWindow(props) {
	const {
		// STR,
		// AGI,
		// VIT,
		// INT,
		// DEX,
		// LUK,
		bonusSTR,
		bonusAGI,
		bonusVIT,
		bonusINT,
		bonusDEX,
		bonusLUK,
		statPoints,
		extraATK,
		bonuses,
		job,
		changeJob,
		changeBaseLevel,
		// baseLevel,
		changeJobLevel,
		// jobLevel,
		// player,
		refreshPlayer,
		setTempInventory,
		skills,
		restoreSkills,
		buffs,
		setBuffs,
	} = useContext(CharacterContext)

	const {
		maxHP,
		maxSP,
		Def,
		softDef,
		softMdef,
		Mdef,
		hit,
		flee,
		perfectDodge,
		crit,
		aspd,
		statusATK,

		// weaponATK,
		baseWeaponDamage,
		statusMATK,
		baseWeaponMagicDamage,
		refinementBonus,
	} = useContext(SubStatsContext)
	const { setIsDbRefreshed } = useContext(DBContext)
	const { token } = useAuth()
	const { compared } = useContext(ComparisonContext)

	const { customStyles } = useContext(UIContext)
	const [savedStats, setsavedStats] = useState({
		str: 1,
		agi: 1,
		vit: 1,
		int: 1,
		dex: 1,
		luk: 1,
	})

	const statList = ['Str', 'Agi', 'Vit', 'Int', 'Dex', 'Luk']
	const bonusStatList = [
		bonusSTR,
		bonusAGI,
		bonusVIT,
		bonusINT,
		bonusDEX,
		bonusLUK,
	]
	const [options, setOptions] = useState([])
	const [selectedValue, setSelectedValue] = useState(null)
	const [slotName, setSlotName] = useState('')
	// The name field is hidden until the user clicks "Rename"; the new name is
	// persisted when they click "Save".
	const [showNameInput, setShowNameInput] = useState(false)

	// One-shot on mount: make sure the 20 slots exist in the v1 format
	// (migrating any legacy save), then build the dropdown.
	useEffect(() => {
		ensureSlots()
		const opts = buildOptions()
		setOptions(opts)
		setSelectedValue(opts[0])
		setSlotName(readSlot(0)?.name ?? '')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const currentSlot = selectedValue ? Number(selectedValue.value) : 0

	const refreshOptions = (slotIndex) => {
		const opts = buildOptions()
		setOptions(opts)
		if (slotIndex != null) {
			setSelectedValue(opts[slotIndex])
			setSlotName(readSlot(slotIndex)?.name ?? '')
		}
	}

	// Refresh the dropdown when a login merge rewrote the local slots.
	useEffect(() => {
		const handler = () => refreshOptions(currentSlot)
		window.addEventListener(BUILDS_SYNCED_EVENT, handler)
		return () => window.removeEventListener(BUILDS_SYNCED_EVENT, handler)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentSlot])

	// ─── Substat comparison (vs the mirror's compared build) ──────────────────
	const curTotals = {
		maxHP,
		maxSP,
		atk: statusATK + baseWeaponDamage + refinementBonus + extraATK,
		def: softDef + Def,
		matk:
			statusMATK +
			baseWeaponMagicDamage +
			refinementBonus +
			(bonuses.bMatk ? bonuses.bMatk : 0),
		mdef: softMdef + Mdef,
		hit,
		flee: flee + perfectDodge,
		crit,
		aspd: Number(aspd),
	}
	const s = compared?.substats
	const savTotals = compared
		? {
				maxHP: s.maxHP,
				maxSP: s.maxSP,
				atk:
					s.statusATK +
					s.baseWeaponDamage +
					s.refinementBonus +
					(compared.extraATK || 0),
				def: s.softDef + s.Def,
				matk:
					s.statusMATK +
					s.baseWeaponMagicDamage +
					s.refinementBonus +
					(compared.bonuses?.bMatk || 0),
				mdef: s.softMdef + s.Mdef,
				hit: s.hit,
				flee: s.flee + s.perfectDodge,
				crit: s.crit,
				aspd: Number(s.aspd),
			}
		: null
	// Δ shown after a substat: green up / red down, hidden when equal.
	const subDelta = (key, decimals = 0) => {
		if (!compared) return null
		const d = curTotals[key] - savTotals[key]
		if (Math.abs(d) < (decimals ? 0.005 : 0.5)) return null
		const mag = decimals
			? Math.abs(d).toFixed(decimals)
			: Math.abs(Math.round(d))
		return (
			<span className={'subDelta ' + (d > 0 ? 'up' : 'down')}>
				{' ('}
				{d > 0 ? '+' : '−'}
				{mag})
			</span>
		)
	}

	return (
		<div className='charWindow'>
			<Cards Name={'Stats'}>
				<Select
					menuPosition='fixed'
					styles={customStyles}
					value={selectedValue}
					id={props.id}
					className='StatSelect'
					onChange={(event) => {
						const slot = Number(event.value)
						setSelectedValue(options[slot])
						setSlotName(readSlot(slot)?.name ?? '')
						setShowNameInput(false)
					}}
					options={options}
				/>
				{showNameInput && (
					<input
						type='text'
						className='SlotNameInput'
						placeholder='Build name'
						maxLength={60}
						value={slotName}
						onChange={(e) => setSlotName(e.target.value)}
						autoFocus
					/>
				)}
				<button
					onClick={() => {
						const player = refreshPlayer()
						const payload = serializeBuild(player, skills, buffs)
						const slot = {
							...payload,
							name: slotName.trim(),
							updatedAt: new Date().toISOString(),
						}
						try {
							writeSlot(currentSlot, slot)
						} catch (error) {
							console.error('failed to write save slot', error)
						}
						refreshOptions(currentSlot)
						if (token) pushSlotToCloud(token, currentSlot)
						setShowNameInput(false)
					}}
				>
					{showNameInput ? 'Save build' : 'Save'}
				</button>
				<button
					onClick={() => {
						const slot = readSlot(currentSlot)
						if (!slot) {
							console.warn('No build in slot', currentSlot)
							return
						}
						const build = deserializeBuild(slot)

						setsavedStats(
							Object.fromEntries(
								statList.map((stat) => [
									stat.toLowerCase(),
									build.stats[stat.toLowerCase()] ?? 1,
								]),
							),
						)
						if (build.job !== job) setIsDbRefreshed(false)
						changeJob(build.job || 0)
						changeBaseLevel(build.baseLevel || 1)
						changeJobLevel(build.jobLevel || 1)
						setTempInventory(build.tempInventory)
						restoreSkills(build.tempSkills)
						setBuffs(cleanBuffs(build.buffs || {}, build.job || 0))
					}}
				>
					Load
				</button>
				{!showNameInput ? (
					<button onClick={() => setShowNameInput(true)}>Rename</button>
				) : (
					<button
						onClick={() => {
							const slot = readSlot(currentSlot)
							if (!slot) return
							writeSlot(currentSlot, {
								...slot,
								name: slotName.trim(),
							})
							refreshOptions(currentSlot)
							if (token) pushSlotToCloud(token, currentSlot)
							setShowNameInput(false)
						}}
					>
						Rename only
					</button>
				)}
				<div className='statsAndSubstats'>
				<div className='chatStats'>
					<span className='LabelJob'>
						{language[props.currentLanguage]['job']}
					</span>
					<div className='SelectJob'>
						<JobSelect
							language='en'
							id='job'
							className=''
							customStyles={customStyles}
						/>
					</div>
					<span className='LabelBaseLv'>
						{language[props.currentLanguage]['baseLevel']}
					</span>
					<div className='SelectBaseLv'>
						<BaseLevelSelect
							id={'baseLevel'}
							className=''
							customStyles={customStyles}
						/>
					</div>
					<span className='LabelJobLv'>
						{language[props.currentLanguage]['jobLevel']}
					</span>
					<div className='SelectJobLv'>
						<JobLevelSelect
							id={'jobLevel'}
							className=''
							customStyles={customStyles}
						/>
					</div>
					{/* Stats labels */}
					{statList.map((st) => (
						<span className={'Label' + st} key={'Label' + st}>
							{
								language[props.currentLanguage][
									st.toLocaleLowerCase()
								]
							}
						</span>
					))}
					{/* Stats selects */}
					{statList.map((st) => (
						<div className={'Select' + st} key={'Select' + st}>
							<StatSelect
								id={st.toLocaleLowerCase()}
								customStyles={customStyles}
								test={savedStats}
							/>
						</div>
					))}
					{/* Stats bonus */}
					{bonusStatList.map((bst, index) => (
						<div
							className={'Bonus' + statList[index]}
							key={'Bonus' + statList[index]}
						>
							{bst >= 0 ? '+' + bst : '-' + bst}
						</div>
					))}
					<div className='LabelStatPointsLeft'>
						<span className='st_col-1 st_row-8'>
							{language[props.currentLanguage]['pointsLeft']}
						</span>
					</div>
					<div className='StatPointsLeft'>
						<div id={'pointsLeft'} className='st_col-2 st_row-8'>
							{statPoints}
						</div>
					</div>
				</div>
				<div className='charSubstats'>
					<div className='subRow'>
						<span className='subLabel'>
							{language[props.currentLanguage].maxHP}
						</span>
						<span className='subValue'>
							{maxHP}
							{subDelta('maxHP')}
						</span>
					</div>
					<div className='subRow'>
						<span className='subLabel'>
							{language[props.currentLanguage].maxSP}
						</span>
						<span className='subValue'>
							{maxSP}
							{subDelta('maxSP')}
						</span>
					</div>
					<div className='subRow'>
						<span className='subLabel'>
							{language[props.currentLanguage].atk}
						</span>
						<span className='subValue'>
							{statusATK} +{' '}
							{baseWeaponDamage + refinementBonus + extraATK}
							{subDelta('atk')}
						</span>
					</div>
					<div className='subRow'>
						<span className='subLabel'>
							{language[props.currentLanguage].def}
						</span>
						<span className='subValue'>
							{softDef} + {Def}
							{subDelta('def')}
						</span>
					</div>
					<div className='subRow'>
						<span className='subLabel'>
							{language[props.currentLanguage].matk}
						</span>
						<span className='subValue'>
							{statusMATK} +{' '}
							{baseWeaponMagicDamage +
								refinementBonus +
								(bonuses.bMatk ? bonuses.bMatk : 0)}
							{subDelta('matk')}
						</span>
					</div>
					<div className='subRow'>
						<span className='subLabel'>
							{language[props.currentLanguage].mdef}
						</span>
						<span className='subValue'>
							{softMdef} + {Mdef}
							{subDelta('mdef')}
						</span>
					</div>
					<div className='subRow'>
						<span className='subLabel'>
							{language[props.currentLanguage].hit}
						</span>
						<span className='subValue'>
							{hit}
							{subDelta('hit')}
						</span>
					</div>
					<div className='subRow'>
						<span className='subLabel'>
							{language[props.currentLanguage].flee}
						</span>
						<span className='subValue'>
							{flee} + {perfectDodge}
							{subDelta('flee')}
						</span>
					</div>
					<div className='subRow'>
						<span className='subLabel'>
							{language[props.currentLanguage].critRate}
						</span>
						<span className='subValue'>
							{crit}
							{subDelta('crit')}
						</span>
					</div>
					<div className='subRow'>
						<span className='subLabel'>
							{language[props.currentLanguage].aspd}
						</span>
						<span className='subValue'>
							{aspd}
							{subDelta('aspd', 2)}
						</span>
					</div>
				</div>
				</div>
				<ComparisonSelect />
			</Cards>
		</div>
	)
}

export default CharWindow
